import { Box, Typography } from '@mui/material';
import React from 'react';
import { ProfessionalQualificationAttribute } from 'resources/professional_qualification_attributes/utils';

function toDisplayValue(answer) {
  const currentValue = answer[answer.type];
  switch (answer.field.type) {
    case 'yes_no':
      return currentValue ? 'Yes' : 'No';
    case 'choices':
      return currentValue.labels?.join?.(', ');
    case 'multiple_choice':
      return currentValue.label || currentValue.labels?.join?.(', ');
    case 'legal':
      return currentValue ? 'Accepted' : 'Rejected';
    default:
      return currentValue;
  }
}

const TypeformShow = ({ record }) => {
  const jsonAttributes = record.admin_professional_qualification_attributes?.filter(
    (pqa) => new ProfessionalQualificationAttribute(pqa).isJson,
  );
  const questions = jsonAttributes?.find((pqa) =>
    pqa.qualification_attribute.slug.toLowerCase().includes('question'),
  );
  const answers = jsonAttributes?.find((pqa) =>
    pqa.qualification_attribute.slug.toLowerCase().includes('answer'),
  );

  if (!questions) {
    return null;
  }

  return (
    <>
      {questions.value?.map((question, index) => {
        const answer = answers.value[index];
        const displayValue = toDisplayValue(answer);
        return (
          <Box key={`${answer.type}-${index}`} my={2}>
            <Typography variant="body2">{question.title}</Typography>
            <Typography variant="caption">{String(displayValue)}</Typography>
          </Box>
        );
      })}
    </>
  );
};

export default TypeformShow;
